import styled, { css } from 'styled-components';
import { colors, media, layout, remCalc } from '@prisjakt/ui-base';
import OutsideClickTrackerBase from '../../../../components/outside-click-tracker';
import { MenuItem } from '../../../sidebar/views/user/styles';

const backgroundPeekWidth = 50;
const offset = {
  mobile: layout.headerHeight.mobile.rem,
  desktop: layout.headerHeight.desktop.rem,
};

const menuColors = {
  background: '#fff',
  border: colors.lightGray1,
  historyBackground: '#428099',
  historyBorder: '#3a7187',
};

const sidebarMenuWidth = `calc(100vw - ${remCalc(backgroundPeekWidth)})`;

export const OutsideClickTracker = styled(OutsideClickTrackerBase)`
  width: ${props => (props.sidebar ? sidebarMenuWidth : 'auto')};

  /* Create a white area to show when swiping the sidebar to the right. */
  ::before {
    background: ${props => props.theme.bg.primary};
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    right: 99%;
    top: 0;
    width: 100%;
  }
`;

const sidebarMenuStyles = () => css`
  background-color: ${props => props.theme.bg.primary};
  height: 100%;
  width: ${sidebarMenuWidth};
`;

const originalMenuStyles = () => css`
  top: ${offset.desktop};
  left: 0;
  right: 0;
  bottom: 0;
  border-top: solid 1px ${menuColors.historyBorder};

  ${media.smallOnly`
    top: ${offset.mobile};
  `};
`;

type MobileMenuProps = {
  sidebar: boolean;
};

export const MobileMenu = styled.nav<MobileMenuProps>`
  ${props => css`
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    position: ${props.sidebar ? 'relative' : 'fixed'};
    z-index: 102;

    ${props.sidebar ? sidebarMenuStyles : originalMenuStyles}
  `}
`;

type HistoryItemProps = {
  centerAligned: boolean;
};

export const HistoryItem = styled(MenuItem)<HistoryItemProps>`
  ${props => css`
    align-items: center;
    display: flex;
    justify-content: flex-start;
    padding-left: ${layout.spacing.xSmall};

    ${props.centerAligned &&
      css`
        padding-right: 28px;
        text-align: center;
      `};

    ${!props.sidebar &&
      css`
        && {
          background-color: ${menuColors.historyBackground};
          border-bottom: 1px solid ${menuColors.historyBorder};
          color: ${colors.white};
        }

        :last-of-type {
          border-color: transparent;
          padding-left: 16px;
        }
      `}
  `};
`;
